export default "__VITE_ASSET__C6lL92Am__"